import React from "react"
import "../../styles/Common/CircleIcon.less"

const CircleIcon = ({ iconStyle = "DefaultCircleIcon", onClick, iconUrl, ...props }) => {
  return <img className={iconStyle} alt={""} src={`assets/${iconUrl}.svg`} onClick={onClick} />
}

export default CircleIcon
